"use client";

import React from "react";

import { type IProjectPayload } from "../../map-panel-context";

import { ProjectBasicInformation } from "./project-basic-information";
import { ProjectScheduledOccupancy } from "./project-scheduled-occupancy";

interface ProjectPanelContentProps {
  payload: IProjectPayload | null;
}

const ProjectPanelContent: React.FC<ProjectPanelContentProps> = React.memo(
  ({ payload }) => {
    return (
      <div className="space-y-6 px-3 py-4">
        <ProjectBasicInformation payload={payload} />
        <ProjectScheduledOccupancy scheduledOccupancy={payload?.scheduledOccupancy ?? []} />
      </div>
    );
  },
);

export default ProjectPanelContent;
